import teamConfig from "../../../../utils/constants/teams";

export const drawerItemsMain = () => {
  return [
    {
      key: "AdminDashboard",
      title: "Dashboard",
      routes: [
        {
          nav: "AdminDashboard",
          routeName: "Admin Dashboard",
          title: "Dashboard",
        },
      ],
    },
    {
      key: "AdminOrganizations",
      title: "Organizations",
      routes: [
        {
          nav: "AdminOrganizations",
          routeName: "AdminOrganizations",
          title: "Organizations",
        },
      ],
    },
    {
      key: "AdminOrganizationalUsers",
      title: "Organizational Users",
      routes: [
        {
          nav: "AdminOrganizationalUsers",
          routeName: "AdminOrganizationalUsers",
          title: "Organizational Users",
        },
      ],
    },
  ];
};
